/* ICE Diamonds — bundle detail modal + card image rotator

   Self-contained. Binds by delegation on document, so it survives the Shopify
   theme editor re-rendering a section without needing a re-init hook.

   RTL NOTE: the carousel advances by translating the track. In an RTL flex row
   the visual direction of "next" is reversed, so the sign of the translate is
   flipped off document.dir rather than hard-coded — the same file then works
   if this section is ever dropped on an LTR store.

   The rotator crossfades stacked images rather than swapping one src. Swapping
   src flashes white on the first cycle before the new file is decoded; stacking
   pre-loads every frame and only animates opacity. */

(function () {
  'use strict';

  var RTL = document.documentElement.dir === 'rtl' || document.dir === 'rtl';

  /* 1800ms holds each frame just long enough to register without the card
     turning into a flicker. The CSS crossfade is 450ms, so roughly a quarter
     of each cycle is the transition itself. */
  var ROTATE_MS = 1800;

  /* ---------------- modal ---------------- */

  function openModal(id) {
    var m = document.querySelector('.ibm[data-ibm="' + id + '"]');
    if (!m) return;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var c = m.querySelector('.ibm__close');
    if (c) c.focus();
    syncCarousel(m.querySelector('.ibm-car'));
  }

  function closeModal(m) {
    if (!m) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function closeAll() {
    document.querySelectorAll('.ibm.is-open').forEach(closeModal);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ibm-open]');
    if (trigger) {
      /* the trigger sits inside the bundle <label>; without this the click
         would also select that bundle on the way up */
      e.preventDefault();
      e.stopPropagation();
      openModal(trigger.getAttribute('data-ibm-open'));
      return;
    }

    if (e.target.closest('.ibm__close')) { closeAll(); return; }

    var overlay = e.target.closest('.ibm');
    if (overlay && !e.target.closest('.ibm__box')) closeModal(overlay);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ---------------- carousel ---------------- */

  function slidesOf(car) {
    return car ? car.querySelectorAll('.ibm-car__slide') : [];
  }

  function indexOf(car) {
    return parseInt(car.getAttribute('data-i') || '0', 10) || 0;
  }

  function goTo(car, i) {
    var n = slidesOf(car).length;
    if (!n) return;
    if (i < 0) i = 0;
    if (i > n - 1) i = n - 1;
    car.setAttribute('data-i', i);
    syncCarousel(car);
  }

  function syncCarousel(car) {
    if (!car) return;
    var slides = slidesOf(car);
    var n = slides.length;
    if (!n) return;

    var i = indexOf(car);
    var track = car.querySelector('.ibm-car__track');
    if (track) track.style.transform = 'translateX(' + (RTL ? i * 100 : -i * 100) + '%)';

    var prev = car.querySelector('.ibm-car__arrow--prev');
    var next = car.querySelector('.ibm-car__arrow--next');
    if (prev) prev.classList.toggle('is-hidden', i === 0);
    if (next) next.classList.toggle('is-hidden', i >= n - 1);

    car.querySelectorAll('.ibm-car__dot').forEach(function (d, k) {
      d.classList.toggle('is-on', k === i);
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.ibm-car__arrow');
    if (arrow) {
      var car = arrow.closest('.ibm-car');
      goTo(car, indexOf(car) + (arrow.classList.contains('ibm-car__arrow--next') ? 1 : -1));
      return;
    }
    var dot = e.target.closest('.ibm-car__dot');
    if (dot) {
      var c2 = dot.closest('.ibm-car');
      goTo(c2, [].indexOf.call(c2.querySelectorAll('.ibm-car__dot'), dot));
    }
  });

  /* swipe — pointer events cover touch and mouse drag in one path */
  var sx = null, sy = null, swiping = null;

  document.addEventListener('pointerdown', function (e) {
    var car = e.target.closest('.ibm-car');
    if (!car) return;
    sx = e.clientX; sy = e.clientY; swiping = car;
  });

  document.addEventListener('pointerup', function (e) {
    if (!swiping || sx === null) { swiping = null; return; }
    var dx = e.clientX - sx;
    var dy = e.clientY - sy;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
      var forward = RTL ? dx > 0 : dx < 0;
      goTo(swiping, indexOf(swiping) + (forward ? 1 : -1));
    }
    sx = sy = null; swiping = null;
  });

  /* ---------------- accordions ---------------- */

  document.addEventListener('click', function (e) {
    var head = e.target.closest('.ibm-acc__head');
    if (!head) return;
    var item = head.closest('.ibm-acc__i');
    var body = item.querySelector('.ibm-acc__body');
    var open = item.classList.toggle('is-open');
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    /* max-height is set to the measured height rather than a guessed large
       value, so the easing curve matches the actual distance travelled */
    body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
  });

  /* ---------------- card image rotator ---------------- */

  function startRotator(rot) {
    var imgs = rot.querySelectorAll('img');
    if (imgs.length < 2) return;

    imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === 0); });

    var i = 0, timer = null;

    function tick() {
      imgs[i].classList.remove('is-on');
      i = (i + 1) % imgs.length;
      imgs[i].classList.add('is-on');
    }

    function play() { if (!timer) timer = setInterval(tick, ROTATE_MS); }
    function pause() { clearInterval(timer); timer = null; }

    /* pausing on hover lets someone actually look at the frame they wanted */
    var card = rot.closest('.itp-bundle') || rot;
    card.addEventListener('mouseenter', pause);
    card.addEventListener('mouseleave', play);

    document.addEventListener('visibilitychange', function () {
      document.hidden ? pause() : play();
    });

    play();
  }

  function init() {
    document.querySelectorAll('.ibm-rot').forEach(function (rot) {
      if (rot.dataset.ibmRotReady) return;
      rot.dataset.ibmRotReady = '1';
      startRotator(rot);
    });
    document.querySelectorAll('.ibm-car').forEach(syncCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', init);
})();
